module.exports = __webpack_public_path__ + "img/zip.20a20ecf.png";